import React from 'react';
import styled from 'styled-components';

import PropTypes from 'prop-types';

import { loadAnim } from '../../containers/Donation/actions';
import { width } from '../../utils/size';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (max-width: 30em) {
        padding: 1.125em 1em;
    }
`;

const AnimationParent = styled.div`
    position: absolute;
    right: -2px;
    left: -2px;
    top: -2px;
    bottom: -2px;
`;

const AnimationWrapper = styled.div`
    width: 100%;
    height: 100%;

    @media (max-width: 30em) {
        width: 480px;
        margin-left: -${(480 - width()) / 2}px;
    }
`;

const setContainer = (element, isMobileResolution) => {
    const container = element;
    if (container) {
        loadAnim(container, isMobileResolution);
    }
};

class DonationSubmitting extends React.Component {
    componentDidMount() {
        setContainer(this.animationWrapper, this.props.isMobileResolution);
    }

    render() {
        return (
            <Container>
                <AnimationParent>
                    <AnimationWrapper
                        innerRef={i => {
                            this.animationWrapper = i;
                        }}
                    />
                </AnimationParent>
            </Container>
        );
    }
}

DonationSubmitting.propTypes = {
    publisherLogoUrl: PropTypes.string,
    isMobileResolution: PropTypes.bool.isRequired
};

export default DonationSubmitting;



// WEBPACK FOOTER //
// ./src/components/Donation/DonationSubmitting.jsx